<template>
  <div :id="id" class="chapter-section panel">
    <p class="panel-heading">{{ $t(`chapter0.title`) }}</p>

    <div class="box">
      <b-field
        :label="$t('chapter0.q0.title')"
        :type="store.getFieldError('personenFachklinikLaufzeit', 'studientitel') ? 'is-danger' : ''"
        :message="store.getFieldError('personenFachklinikLaufzeit', 'studientitel')"
      >
        <b-input
          :required="true"
          v-model="study.personenFachklinikLaufzeit.studientitel"
          @blur="save"
        />
      </b-field>
    </div>

    <fieldset class="box">
      <legend>{{ $t(`chapter0.q1.title`) }}</legend>
      <b-field :label="$t(`chapter0.q1.akadTitel`)">
        <b-input
          v-model="study.personenFachklinikLaufzeit.principalInvestigator.academicTitle"
          @blur="save"
        />
      </b-field>
      <b-field
        :label="$t(`chapter0.q1.vorname`)"
        :type="
          store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.firstName')
            ? 'is-danger'
            : ''
        "
        :message="
          store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.firstName')
        "
      >
        <b-input
          :required="true"
          v-model="study.personenFachklinikLaufzeit.principalInvestigator.firstName"
          @blur="save"
        />
      </b-field>
      <b-field
        :label="$t(`chapter0.q1.nachname`)"
        :type="
          store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.lastName')
            ? 'is-danger'
            : ''
        "
        :message="
          store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.lastName')
        "
      >
        <b-input
          :required="true"
          v-model="study.personenFachklinikLaufzeit.principalInvestigator.lastName"
          @blur="save"
        />
      </b-field>
      <b-field
        :label="$t(`chapter0.q1.mail`)"
        :type="
          store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.email')
            ? 'is-danger'
            : ''
        "
        :message="store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.email')"
      >
        <b-input
          type="email"
          :required="true"
          v-model="study.personenFachklinikLaufzeit.principalInvestigator.email"
          @blur="save"
        />
      </b-field>
      <b-field
        :type="
          store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.klinik')
            ? 'is-danger'
            : ''
        "
        :message="store.getFieldError('personenFachklinikLaufzeit', 'principalInvestigator.klinik')"
      >
        <template #label>
          {{ $t(`chapter0.q1.klinik`) }}<span class="required-asterisk"> *</span>
        </template>
        <b-taginput
          ref="piKlinikTaginput"
          v-model="study.personenFachklinikLaufzeit.principalInvestigator.klinik"
          :data="piKlinikSearch.filtered"
          autocomplete
          size="is-medium"
          :open-on-focus="true"
          :allow-new="true"
          :maxtags="5"
          field="displayLabel"
          :create-tag="createClinicTag"
          :placeholder="$t('chapter0.q1.klinikPlaceholder')"
          @typing="piKlinikSearch.onTyping"
          @update:model-value="save"
          @add="cancelTaginputFlush(piKlinikTaginput)"
          @blur="flushTaginputOnBlur($event, piKlinikTaginput)"
        >
          <template #tag="{ tag }">
            <b-tooltip
              :label="klinikTagTooltip(tag)"
              position="is-top"
              type="is-info"
              multilined
              append-to-body
            >
              {{ klinikTagLabel(tag) }}
            </b-tooltip>
          </template>
        </b-taginput>
      </b-field>
    </fieldset>

    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          <b-field class="is-flex is-justify-content-flex-start">
            <b-switch v-model="hasDifferentAnsprechpartner" type="is-success">
              {{ $t(`chapter0.q2.title`) }}
            </b-switch>
          </b-field>
        </p>
      </header>
      <div class="card-content">
        <fieldset v-if="study.personenFachklinikLaufzeit.ansprechpartner">
          <b-field :label="$t(`chapter0.q1.akadTitel`)">
            <b-input
              v-model="study.personenFachklinikLaufzeit.ansprechpartner.academicTitle"
              @blur="save"
            />
          </b-field>
          <b-field
            :label="$t(`chapter0.q1.vorname`)"
            :type="
              store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.firstName')
                ? 'is-danger'
                : ''
            "
            :message="
              store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.firstName')
            "
          >
            <b-input
              :required="hasDifferentAnsprechpartner"
              v-model="study.personenFachklinikLaufzeit.ansprechpartner.firstName"
              @blur="save"
            />
          </b-field>
          <b-field
            :label="$t(`chapter0.q1.nachname`)"
            :type="
              store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.lastName')
                ? 'is-danger'
                : ''
            "
            :message="store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.lastName')"
          >
            <b-input
              :required="hasDifferentAnsprechpartner"
              v-model="study.personenFachklinikLaufzeit.ansprechpartner.lastName"
              @blur="save"
            />
          </b-field>
          <b-field
            :label="$t(`chapter0.q1.mail`)"
            :type="
              store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.email')
                ? 'is-danger'
                : ''
            "
            :message="store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.email')"
          >
            <b-input
              type="email"
              :required="hasDifferentAnsprechpartner"
              v-model="study.personenFachklinikLaufzeit.ansprechpartner.email"
              @blur="save"
            />
          </b-field>
          <b-field
            :type="
              store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.klinik')
                ? 'is-danger'
                : ''
            "
            :message="store.getFieldError('personenFachklinikLaufzeit', 'ansprechpartner.klinik')"
          >
            <template #label>
              {{ $t(`chapter0.q1.klinik`) }}<span class="required-asterisk"> *</span>
            </template>
            <b-taginput
              ref="apKlinikTaginput"
              v-model="study.personenFachklinikLaufzeit.ansprechpartner.klinik"
              :data="apKlinikSearch.filtered"
              autocomplete
              size="is-medium"
              :open-on-focus="true"
              :allow-new="true"
              :maxtags="5"
              field="displayLabel"
              :create-tag="createClinicTag"
              :placeholder="$t('chapter0.q1.klinikPlaceholder')"
              @typing="apKlinikSearch.onTyping"
              @update:model-value="save"
              @add="cancelTaginputFlush(apKlinikTaginput)"
              @blur="flushTaginputOnBlur($event, apKlinikTaginput)"
            >
              <template #tag="{ tag }">
                <b-tooltip
                  :label="klinikTagTooltip(tag)"
                  position="is-top"
                  type="is-info"
                  multilined
                  append-to-body
                >
                  {{ klinikTagLabel(tag) }}
                </b-tooltip>
              </template>
            </b-taginput>
          </b-field>
        </fieldset>
      </div>
    </div>

    <div class="box">
      <b-field :label="$t(`chapter0.q3.title`)">
        <b-taginput
          ref="verantwortlicheFachabteilungTaginput"
          v-model="study.personenFachklinikLaufzeit.verantwortlicheFachabteilung"
          :data="verantwortlicheFachabteilungSearch.filtered"
          autocomplete
          size="is-medium"
          :open-on-focus="true"
          :allow-new="true"
          :maxtags="5"
          field="displayLabel"
          :create-tag="createClinicTag"
          :placeholder="$t(`chapter0.q3.placeholder`)"
          @typing="verantwortlicheFachabteilungSearch.onTyping"
          @update:model-value="save"
          @add="cancelTaginputFlush(verantwortlicheFachabteilungTaginput)"
          @blur="flushTaginputOnBlur($event, verantwortlicheFachabteilungTaginput)"
        >
          <template #tag="{ tag }">
            <b-tooltip
              :label="klinikTagTooltip(tag)"
              position="is-top"
              type="is-info"
              multilined
              append-to-body
            >
              {{ klinikTagLabel(tag) }}
            </b-tooltip>
          </template>
        </b-taginput>
      </b-field>
    </div>

    <fieldset class="box">
      <legend>
        {{ $t(`chapter0.q4.title`) }}
        <b-tooltip :label="$t(`general.showInfo`)" position="is-right" type="is-info">
          <b-icon
            type="is-info"
            icon="information-variant"
            class="info-toggle"
            :class="{ 'is-active': showInfo_c0q4 }"
            @click.native="showInfo_c0q4 = !showInfo_c0q4"
          />
        </b-tooltip>
      </legend>

      <InfoText :button-label="$t('general.showInfo')" v-if="showInfo_c0q4">
        {{ $t('chapter0.q4.info') }}
      </InfoText>

      <b-field
        :label="$t(`chapter0.q4.start`)"
        :type="
          store.getFieldError('personenFachklinikLaufzeit', 'laufzeit.startDate') ? 'is-danger' : ''
        "
        :message="store.getFieldError('personenFachklinikLaufzeit', 'laufzeit.startDate')"
      >
        <b-datepicker
          :required="true"
          :use-html5-validation="false"
          v-model="startDate"
          editable
          icon-right="calendar-today"
          icon-right-clickable
          placeholder="dd.MM.yyyy"
          :date-formatter="formatDisplayDate"
          :date-parser="parseDisplayDate"
        />
      </b-field>
      <b-field
        :label="$t(`chapter0.q4.end`)"
        :type="
          store.getFieldError('personenFachklinikLaufzeit', 'laufzeit.endDate') ? 'is-danger' : ''
        "
        :message="store.getFieldError('personenFachklinikLaufzeit', 'laufzeit.endDate')"
      >
        <b-datepicker
          :use-html5-validation="false"
          v-model="endDate"
          editable
          icon-right="calendar-today"
          icon-right-clickable
          placeholder="dd.MM.yyyy"
          :date-formatter="formatDisplayDate"
          :date-parser="parseDisplayDate"
        />
      </b-field>
      <b-field class="is-flex is-justify-content-flex-start">
        <b-checkbox
          v-model="study.personenFachklinikLaufzeit.ohneEnddatum"
          type="is-success"
          @change="save"
        >
          {{ $t(`chapter0.q4.ohne`) }}
        </b-checkbox>
      </b-field>
      <AbweichungStandardprozess v-if="study.personenFachklinikLaufzeit.ohneEnddatum">
        {{ $t('general.abweichungStandardprozess') }}
      </AbweichungStandardprozess>
    </fieldset>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStudyStore } from '@/stores/studyStore'
import { useInfoToggle } from '@/composables/useVisibilityToggles'
import InfoText from '@/components/InfoText.vue'
import {
  BCheckbox,
  BDatepicker,
  BField,
  BIcon,
  BInput,
  BNumberinput,
  BSwitch,
  BTaginput,
  BTooltip,
} from 'buefy'
import AbweichungStandardprozess from '@/components/AbweichungStandardprozess.vue'

defineProps<{ id: string; modelValue?: object }>()

const { t } = useI18n()
const store = useStudyStore()
const study = store.study

interface Klinik {
  abbr: string
  name: string
  displayLabel: string
}

const allKliniken = ref<Klinik[]>([])

fetch('/fachklinik-liste.txt')
  .then((r) => r.text())
  .then((text) => {
    allKliniken.value = text
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .map((line) => {
        const separatorIndex = line.indexOf(';')
        const abbr = separatorIndex === -1 ? line : line.slice(0, separatorIndex).trim()
        const name = separatorIndex === -1 ? '' : line.slice(separatorIndex + 1).trim()
        return { abbr, name, displayLabel: `${name} (${abbr})` }
      })
  })

const klinikByDisplayLabel = computed(
  () => new Map(allKliniken.value.map((k) => [k.displayLabel, k])),
)

function createClinicTag(tag: unknown): string {
  if (tag && typeof tag === 'object' && 'displayLabel' in tag) {
    return (tag as Klinik).displayLabel
  }
  return String(tag).trim()
}

function klinikTagLabel(tag: string): string {
  const known = klinikByDisplayLabel.value.get(tag)
  return known ? known.abbr : t('chapter0.q1.eigeneKlinik')
}

function klinikTagTooltip(tag: string): string {
  const known = klinikByDisplayLabel.value.get(tag)
  return known ? known.name : tag
}

function useKlinikSearch() {
  const search = ref('')
  const filtered = computed(() => {
    const term = search.value.trim().toLowerCase()
    if (!term) return allKliniken.value
    return allKliniken.value.filter((k) => k.displayLabel.toLowerCase().includes(term))
  })
  const onTyping = (text: string | number | undefined) => {
    search.value = text?.toString() ?? ''
  }
  return reactive({ search, filtered, onTyping })
}

const piKlinikSearch = useKlinikSearch()
const apKlinikSearch = useKlinikSearch()
const verantwortlicheFachabteilungSearch = useKlinikSearch()

const piKlinikTaginput = ref<InstanceType<typeof BTaginput> | null>(null)
const apKlinikTaginput = ref<InstanceType<typeof BTaginput> | null>(null)
const verantwortlicheFachabteilungTaginput = ref<InstanceType<typeof BTaginput> | null>(null)

const save = () => {
  store.updateChapter('personenFachklinikLaufzeit', study.personenFachklinikLaufzeit)
}

// The store keeps the laufzeit dates as 'yyyy-MM-dd' strings (as produced by the
// previous native date input), while b-datepicker works with Date objects.
function parseIsoDate(value: string | undefined): Date | null {
  if (!value) return null
  const [year, month, day] = value.split('-').map(Number)
  if (!year || !month || !day) return null
  const date = new Date(year, month - 1, day)
  return isNaN(date.valueOf()) ? null : date
}

function formatIsoDate(date: Date | null): string | undefined {
  if (!date || isNaN(date.valueOf())) return undefined
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// Displayed/typed format is dd.MM.yyyy, independent of the browser locale.
function formatDisplayDate(date: Date | Date[]): string {
  const single = Array.isArray(date) ? (date[0] ?? new Date(NaN)) : date
  const day = String(single.getDate()).padStart(2, '0')
  const month = String(single.getMonth() + 1).padStart(2, '0')
  const year = single.getFullYear()
  return `${day}.${month}.${year}`
}

function parseDisplayDate(value: string): Date | null {
  const match = value.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/)
  if (!match) return null
  const [, day, month, year] = match
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  return isNaN(date.valueOf()) ? null : date
}

const startDate = computed<Date | null>({
  get: () => parseIsoDate(study.personenFachklinikLaufzeit.laufzeit.startDate),
  set: (value) => {
    study.personenFachklinikLaufzeit.laufzeit.startDate = formatIsoDate(value)
    save()
  },
})

const endDate = computed<Date | null>({
  get: () => parseIsoDate(study.personenFachklinikLaufzeit.laufzeit.endDate),
  set: (value) => {
    study.personenFachklinikLaufzeit.laufzeit.endDate = formatIsoDate(value)
    save()
  },
})

// Buefy's taginput only commits an in-progress entry to a tag on Enter/Tab;
// losing focus otherwise discards it, so we flush it manually on blur. But
// blur also fires when the user clicks a suggestion, since the dropdown
// options are focusable and the click moves focus onto one of them first -
// naively flushing there would re-add the text the user searched with as a
// second, bogus tag alongside the one they actually picked.
// `event.relatedTarget` tells us where focus is going: if it's landing
// inside this same taginput (i.e. on one of its own suggestions), that's a
// selection in progress, not a real "leaving the field" - so we skip the
// flush entirely. As a fallback for cases relatedTarget can't cover (e.g.
// selecting via keyboard while the flush is already scheduled), the 'add'
// event - fired for every tag add, however it happened - cancels any
// pending flush too.
const pendingTaginputFlush = new WeakMap<
  InstanceType<typeof BTaginput>,
  ReturnType<typeof setTimeout>
>()

function cancelTaginputFlush(taginput: InstanceType<typeof BTaginput> | null) {
  if (!taginput) return
  const timer = pendingTaginputFlush.get(taginput)
  if (timer !== undefined) {
    clearTimeout(timer)
    pendingTaginputFlush.delete(taginput)
  }
}

function flushTaginputOnBlur(
  event: Event | undefined,
  taginput: InstanceType<typeof BTaginput> | null,
) {
  if (!taginput) return
  const nextFocusTarget = (event as FocusEvent | undefined)?.relatedTarget as Node | null
  if (nextFocusTarget && taginput.$el.contains(nextFocusTarget)) return

  const timer = setTimeout(() => {
    pendingTaginputFlush.delete(taginput)
    if (taginput.newTag?.trim()) {
      taginput.addTag()
    }
    save()
  }, 150)
  pendingTaginputFlush.set(taginput, timer)
}

function enableAnsprechpartner() {
  study.personenFachklinikLaufzeit.ansprechpartner = {
    firstName: '',
    lastName: '',
    email: '',
    klinik: [],
  }
}

function disableAnsprechpartner() {
  study.personenFachklinikLaufzeit.ansprechpartner = undefined
}

const hasDifferentAnsprechpartner = computed({
  get() {
    return !!study.personenFachklinikLaufzeit.ansprechpartner
  },
  set(value: boolean) {
    if (value) {
      enableAnsprechpartner()
    } else {
      disableAnsprechpartner()
    }
  },
})

const showInfo_c0q4 = useInfoToggle()
</script>

<style scoped>
.required-asterisk {
  color: red;
}
</style>
